import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow p-8">
        <h1 className="text-3xl font-bold mb-8 text-gray-900">Privacy Policy</h1>
        
        <div className="space-y-6 text-gray-600">
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Introduction</h2>
            <p>Welcome to Linkforce AI. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI chatbot service and website.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Information We Collect</h2>
            <h3 className="text-xl font-medium mb-2">2.1 Information You Provide</h3>
            <ul className="list-disc pl-6 mb-4">
              <li>Account information (email, password, profile details)</li>
              <li>Billing and payment information</li>
              <li>Chatbot configuration and customization data</li>
              <li>Communication preferences</li>
            </ul>
            
            <h3 className="text-xl font-medium mb-2">2.2 Automatically Collected Information</h3>
            <ul className="list-disc pl-6">
              <li>Usage data and analytics</li>
              <li>Device and browser information</li>
              <li>IP addresses and location data</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. How We Use Your Information</h2>
            <ul className="list-disc pl-6">
              <li>To provide and maintain our AI chatbot service</li>
              <li>To process your transactions and subscriptions</li>
              <li>To improve and personalize our services</li>
              <li>To communicate with you about service updates</li>
              <li>To ensure compliance with our terms and policies</li>
              <li>To detect and prevent fraud or abuse</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Data Security</h2>
            <p>We implement appropriate technical and organizational security measures to protect your information. However, no system is completely secure, and we cannot guarantee the absolute security of your data.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Third-Party Services</h2>
            <p>Our service may integrate with or use third-party services. These services have their own privacy policies, and we recommend reviewing them. We are not responsible for the privacy practices of third-party services.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Data Retention</h2>
            <p>We retain your information for as long as necessary to provide our services and comply with legal obligations. You can request deletion of your account and associated data at any time.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Your Rights</h2>
            <p>Depending on your location, you may have rights regarding your personal data, including:</p>
            <ul className="list-disc pl-6">
              <li>Access to your data</li>
              <li>Correction of inaccurate data</li>
              <li>Deletion of your data</li>
              <li>Restriction of processing</li>
              <li>Data portability</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Updates to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.</p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy, please contact us at:</p>
            <p className="mt-2">Email: forbusinessenquiries10@gmail.com</p>
          </section>

          <p className="text-sm text-gray-500 mt-8">Last Updated: {new Date().toLocaleDateString()}</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 